<div class="b-radius-max _outer"
     [class.b-a]="selected || isCheckbox()"
     [ngClass]="isCheckbox() ? 'b-col-b' : 'b-col-12'">

    <div class="b-col-5 b-a b-radius-max overflow-hidden">
        @switch (getType()) {
        <!-- image -->
        @case ('image') {
        <df-image-wrapper>
            <img class="w-12"
                 [ratio]="1"
                 [dfImage]="swatch"
                 [alt]="altText" />
        </df-image-wrapper>
        }
        <!-- color -->
        @case ('background') {
        <span class="ratio-1-1 block"
              [style.background-color]="swatch"></span>
        }
        <!-- checkbox -->
        @default {
        <span class="ratio-1-1 block"></span>
        }
        }
    </div>
</div>
